/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceStepResponseScheduleMode = typeof SequenceStepResponseScheduleMode[keyof typeof SequenceStepResponseScheduleMode];


export const SequenceStepResponseScheduleMode = {
  immediate: 'immediate',
  soonest_at: 'soonest_at',
  delay: 'delay',
} as const;
